<template>
  <main id="subPage" class="admin">
    <!-- 카테고리 -->
    <section id="category">
      <h2>관리자 메뉴</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">관리자 메뉴</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
            <li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
          </ul>
        </li>
        <li class="web">
          <p class="pageTxt">팝업/배너관리</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="회원관리">회원관리</router-link></li>
            <li><router-link to="/discountvehicle" title="할인차량관리">할인차량관리</router-link></li>
            <li><router-link to="/periodparking" title="정기권 주차장관리">정기권 주차장관리</router-link></li>
            <li><router-link to="/noticemanagement" title="게시판관리">게시판관리</router-link></li>
            <li><router-link to="/popuplist" title="팝업/배너관리">팝업/배너관리</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">팝업관리</p>
          <ul class="depth">
            <li><router-link to="/popuplist" title="팝업관리">팝업관리</router-link></li>
            <li><router-link to="/bannerlist" title="배너관리">배너관리</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">팝업 수정</h3>
        <article>
          <!--table-->
          <div class="table horizontal-table">
            <table>
              <caption>
                팝업 수정 테이블
              </caption>
              <colgroup>
                <col style="width: 15%" />
                <col style="width: 35%" />
                <col style="width: 15%" />
                <col style="width: 35%" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">제목<span class="redDot">*</span></th>
                  <td colspan="3">
                    <input type="text" title="제목 입력" v-model="title" />
                  </td>
                </tr>
                <tr>
                  <th scope="row">게시기간<span class="redDot">*</span></th>
                  <td colspan="3">
                    <date-picker v-bind:props-date="searchDate" v-model="searchDate"></date-picker>
                  </td>
                </tr>
                <tr>
                  <th scope="row">사용여부</th>
                  <td>
                    <div class="radioGroup" v-if="useYn === 'Y'">
                      <p class="radio">
                        <input
                          type="radio"
                          id="radio-01"
                          name="radio"
                          class="hidden"
                          v-model="useYn"
                          value="Y"
                          checked
                        />
                        <label for="radio-01">사용함</label>
                      </p>
                      <p class="radio">
                        <input type="radio" id="radio-02" name="radio" class="hidden" value="N" />
                        <label for="radio-02">사용안함</label>
                      </p>
                    </div>
                    <div class="radioGroup" v-else>
                      <p class="radio">
                        <input type="radio" id="radio-01" name="radio" class="hidden" v-model="useYn" value="Y" />
                        <label for="radio-01">사용함</label>
                      </p>
                      <p class="radio">
                        <input
                          type="radio"
                          id="radio-02"
                          name="radio"
                          class="hidden"
                          v-model="useYn"
                          value="N"
                          checked
                        />
                        <label for="radio-02">사용안함</label>
                      </p>
                    </div>
                  </td>
                  <th scope="row">위치</th>
                  <td>
                    <div class="flex">
                      <div class="col">
                        <span>X</span> <input type="text" title="가로 위치 입력" v-model="posX" class="sm" />
                      </div>
                      <div class="col">
                        <span>Y</span> <input type="text" title="세로 위치 입력" class="sm" v-model="posY" />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">크기</th>
                  <td colspan="3">
                    <div class="flex">
                      <div class="col">
                        <span>가로</span> <input type="text" title="가로 길이 입력" v-model="sizeX" class="sm" />
                      </div>
                      <div class="col">
                        <span>세로</span> <input type="text" title="세로 길이 입력" v-model="sizeY" class="sm" />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">링크주소<span class="redDot">*</span></th>
                  <td colspan="3">
                    <input type="text" title="링크주소 입력" class="md" v-model="linkUrl" />
                    <p class="info">링크가 없을 경우 공백으로 작성해주세요</p>
                  </td>
                </tr>
                <tr>
                  <th scope="row">팝업내용<span class="redDot">*</span></th>
                  <td colspan="3">
                    <div id="ckeditorTA">
                      <ckeditor
                        :editor="editor"
                        v-model="popupContents"
                        :config="editorConfig"
                        @ready="onReady"
                      ></ckeditor>
                    </div>
                  </td>
                </tr>
                <!-- <tr>
                                    <th scope="row">첨부파일</th>
                                    <td colspan="3">
                                        <div class="fileArea">
                                            <p class="upload-name">{{firstName}}</p>
                                            <input type="file" class="hidden" id="file" ref="files" @change="changeFile" @click="resetFile" />
                                            <label for="file" class="btn gray">파일첨부</label>
                                        </div>
                                        <p class="info">첨부파일 (최대용량:20M) *이미지 파일 (jpg, jpeg, gif, png, pdf)</p>
                                    </td>
                                </tr>-->
              </tbody>
            </table>
          </div>
          <!--table-->
        </article>
        <article class="btnArea">
          <button class="btn border" @click="$router.push('popuplist')">목록</button>
          <button class="btn gray" @click="popupPreview">미리보기</button>
          <button class="btn blue" @click="updateBtn">저장</button>
        </article>
      </div>
    </section>

    <!-- 미리보기 -->
    <popup v-if="showModal">
      <template #info>
        {{ title }}
      </template>
      <template #content>
        <article>
          <article><p v-html="contents"></p></article>
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CloseBtn"><span class="hidden">닫기</span></button>
      </template>
    </popup>
  </main>
</template>

<script>
import DatePicker from '../../../components/DatePicker2.vue';
import Popup from '../../../components/PopupType1.vue';
import axios from '../../../util/axios';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import { required, between } from 'vuelidate/lib/validators';
import '@ckeditor/ckeditor5-build-classic/build/translations/ko';
const uploadAdapter = require('../../../assets/js/UploadAdapter');

export default {
  data() {
    return {
      showModal: false,
      listData: [],
      curPageNum: 1,
      dataPerPage: 10,
      firstName: '파일명',
      editor: ClassicEditor,

      popupId: '',
      title: '',
      openDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      closeDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      useYn: '',
      posX: '',
      posY: '',
      sizeX: '',
      sizeY: '',
      linkUrl: '',
      popupContents: '',
      editorConfig       : {
				language         : 'ko',
				enterMode        : 2,
				shiftEnterMode   : 3,
				extraPlugins     : [ uploadAdapter.MyCustomUploadAdapterPlugin ],
				mediaEmbed       : {
					previewsInData : true,
				}
			},
      searchDate: {
        startDate: '',
        endDate: '',
      },
    };
  },

  components: {
    DatePicker,
    Popup,
    ckeditor: CKEditor.component,
  },

  created() {
    const ff = this.$route.params;
    const popupData = ff.data;

    if (!popupData) {
      alert('정보가 없습니다.');
      this.$router.push('/popuplist');
      return;
    }

    this.popupId = popupData.popupId;
    this.title = popupData.title;
    this.useYn = popupData.useYn;
    this.posX = popupData.posX;
    this.posY = popupData.posY;
    this.sizeX = popupData.sizeX;
    this.sizeY = popupData.sizeY;
    this.linkUrl = popupData.linkUrl;
    this.popupContents = popupData.popupContents;
    this.searchDate.startDate = popupData.openDate;
    this.searchDate.endDate = popupData.closeDate;
  },
  validations: {
    title: {
      required,
    },
    openDate: {
      required,
    },
    closeDate: {
      required,
    },
    useYn: {
      required,
    },
    posX: {
      required,
    },
    posY: {
      required,
    },
    sizeX: {
      required,
    },
    sizeY: {
      required,
      between: between(0, 640),
    },
  },
  methods: {
    async updateBtn() {
      let apiParams = new FormData();
      apiParams.append('popupId', this.popupId);
      apiParams.append('title', this.title);
      apiParams.append('popupContents', this.popupContents);
      apiParams.append('openDateString', this.searchDate.startDate);
      apiParams.append('closeDateString', this.searchDate.endDate + ' 23:59:59');
      apiParams.append('useYn', this.useYn);
      apiParams.append('posX', this.posX);
      apiParams.append('posY', this.posY);
      apiParams.append('sizeX', this.sizeX);
      apiParams.append('sizeY', this.sizeY);
      apiParams.append('linkUrl', this.linkUrl);
      await axios('post', '/api/admin/popup/updateAction.json', apiParams)
        .then(response => {
          let message = response.data.message;
          alert(message);
          this.$router.push('popuplist');
        })
        .catch(function (error) {
          console.error(error);
        });
    },

    onReady(editor) {
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement(),
          editor.setData(this.popupContents),
        );
    },

    changeFile(e) {
      let file = e.target.files[0];

      if (file['type'] === 'image/jpeg' || file['type'] === 'image/png' || file['type'] === 'image/gif') {
        this.firstName = file.name;
        this.eFiles = file;
      } else {
        alert('PNG/JPEG/GIF 형식만 가능합니다.');
        this.$refs.files.value = '';
        this.eFiles = '';
      }
    },

    resetFile() {
      this.$refs.files.value = '';
      this.eFiles = [];
    },

    CloseBtn() {
      this.showModal = false;
    },

    popupPreview() {
      this.showModal = true;
    },
  },

  computed: {
    numOfPages() {
      return Math.ceil(this.listData.length / this.dataPerPage);
    },
  },
};
</script>
